import { gql } from '@apollo/client';
import { Category } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const getCategoryOnly = (name: string) => gql`
  query ${name} ($params: GetCategoryParams!) {
  category(params: $params ) {
    name
    slug
    id
    products {
        id
        uuid
        slug
        name
        price
        discount {
          price
          type
          stockRestriction
          dateRestriction
          listPrice
        }
        concentration
        unit
        format
        quantity
        package
        composition
        display
        containerQuantity
        container
        availability {
          status
          statusWithoutStock
          discountStock
          stock
        }
        imagesUrl
        activePrinciple
        laboratory
        isCheapestActivePrinciple
    }
  }
}
`;

export type getCategoryOnlyQueryParams = ResolverParams<{
  slug: string;
}>;

export type getCategoryOnlyQueryResponse = {
  category: Category;
};
